module.exports = __webpack_public_path__ + "static/media/transfer_a_person.cb925e19.svg";